import { configureStore } from "./configureStore";

const { store, apiSaga } = configureStore();
export { store, apiSaga };
